





























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import ContentLayout from '@/apps/open/layout/ContentLayout.vue'
import Button from '@components/Button'
import Block from '@/apps/open/layout/Block.vue'
import Setting from '@/apps/open/layout/Setting.vue'
import { deleteApp, getHasExistSpace } from '@/apps/open/services/app'
import { getSelectOptionLabel, onRequestError } from '@/apps/open/utils'
import { APP_TYPE_OPTIONS } from '@/apps/open/options/app'
import moment from 'moment'
import VerifyPhoneMixin from '@/apps/open/mixins/VerifyPhone'
import { EVerifyPhoneAction } from '@/apps/open/types'
import { IAppInfo } from '@/apps/open/store/modules/app/types'

@Component({
  components: {
    ContentLayout,
    Button,
    Block,
    Setting
  }
})
export default class AppInfo extends Mixins(VerifyPhoneMixin) {
  labelWidth = 100
  open_ssid = ''
  hasExitSpace = false

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get appId () {
    return this.$route.params.id
  }

  get appInfo (): IAppInfo {
    return this.$store.getters['App/appInfo']
  }

  get appType () {
    return this.appInfo.is_sandbox ? '测试应用' : '正式应用'
  }

  get appPlatform () {
    return getSelectOptionLabel(this.appInfo.app_type || '', APP_TYPE_OPTIONS)
  }

  get appCreator () {
    return this.appInfo.creator || {}
  }

  get createTime () {
    return this.appInfo.create_at ? moment(this.appInfo.create_at * 1000).format('YYYY-MM-DD HH:mm:ss') : ''
  }

  get editRoute () {
    return { name: 'add-app', params: { id: this.appId } }
  }

  get isAppAdmin () {
    return this.$store.getters['isAppAdmin']
  }

  async getHasExistSpace () {
    // TODO: 企业ID暂时硬编码，后续需替换
    // 接口等待联调
    const res = await getHasExistSpace(this.appId, '671085136')
    if (res.data) {
      this.hasExitSpace = Boolean(res.data.exist)
    }
  }

  deleteNotice () {
    this.$dialog.show({
      title: '删除须知',
      body: '根据相关法律法规及政策，你应当承诺并确保，在你删除你的相关应用或停止以第三方服务商身份为用户提供服务后，立即删除从WPS开放平台所获取的用户数据、开放平台运营数据等数据信息。同时，你应当确保你所合法授权接触、使用、获得上述数据的任何第三方也立即对相关数据进行删除处理。',
      buttons: [
        { text: '取消' },
        {
          text: '我已了解，下一步',
          type: 'primary',
          fn: () => {
            this.isPrivate ? this.deletePriConfirm() : this.verifyPhone({
              title: '删除应用',
              action: EVerifyPhoneAction.DELETE_APP,
              cb: this.deleteConfirm
            })
          }
        }
      ]
    })
  }

  deletePriConfirm () {
    const dialogBody = `
      <div>
        <div style="font-weight: 600">确定要删除应用吗？</div>
        <div>删除应用后，将无法恢复，${this.hasExitSpace ? '会同时移除应用空间下的文档，' : ''} 应用的APPID和APPKEY将失效，相关权限功能也将失效，请确认是否对应用进行删除？</div>
      </div>
    `
    this.$dialog.show({
      title: '删除应用',
      body: dialogBody,
      buttons: [
        { text: '取消' },
        { text: '确定',
          type: 'primary',
          fn: this.deleteApp
        }
      ]
    })
  }

  deleteConfirm (open_ssid: string) {
    this.open_ssid = open_ssid
    const dialogBody = `
      <div>
        <div style="font-weight: 600">确定要删除应用吗？</div>
        <div>删除应用后，将无法恢复，应用的APPID和APPKEY将失效，相关权限功能也将失效</div>
      </div>
    `
    this.$dialog.show({
      title: '删除应用',
      body: dialogBody,
      buttons: [
        { text: '取消' },
        { text: '确定',
          type: 'primary',
          fn: this.deleteApp
        }
      ]
    })
  }

  async deleteApp () {
    try {
      await deleteApp(this.appId, this.open_ssid)
      this.$dialog.close()
      this.$message.success('删除成功')
      this.$router.push(({ name: 'developer-info' }))
    } catch (error) {
      onRequestError(error)
    }
  }

  mounted () {
    try {
      this.getHasExistSpace()
      this.$store.dispatch('App/GET_APP_INFO', this.appId)
      this.$store.dispatch('Admin/GET_ADMIN_LIST')
    } catch (error) {
      onRequestError(error)
    }
  }
}
